import React from 'react';

import { selectCommandByNodeId, State } from '@store/index';
import { useSelector } from 'react-redux';
import { NodeSidebarHeader } from '@common/Node/NodeSidebar/NodeSidebarHeader';
import { NodeSidebarContainer } from '@common/Node/NodeSidebar/NodeSidebarContainer';
import { ResponseTabs } from './Tabs';

export const ResponseSidebar: React.FC = () => {
  const command = useSelector((state: State) => selectCommandByNodeId(state, state.tabs.active.selectedNode));
  if (!command) return <NodeSidebarContainer />;

  return (
    <NodeSidebarContainer>
      <NodeSidebarHeader command={command} />
      <ResponseTabs />
    </NodeSidebarContainer>
  );
};
